// validations.ts
export const validatePrebookPrice = (value, mrp) => {
  if (!value) return 'Price is required';

  const price = parseInt(value, 10);
  if (isNaN(price)) return 'Invalid price format';

  // if (isFullPayment) {
  if (price > mrp) {
    return 'Prebook price cannot exceed MRP';
  }
  // }
  // else {
  // For partial payment, price should be less than VSP
  // const vsp = parseInt(
  //   document.querySelector(`input[id^='vs-price-']`)?.value,
  //   10
  // );
  //   const vsp = parseInt(mrp, 10);
  //   console.log(vsp, price);
  //   if (price >= vsp) {
  //     return 'Prebook price should be less than VSP for partial payment';
  //   }
  // }

  return null;
};

export const validateVsPrice = (value, mrp) => {
  if (value && parseInt(value, 10) > mrp) {
    return 'Vsp price cannot exceed MRP';
  }
  return null;
};
